var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuAppAuto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#22272A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.241 20.578h3.295V16.51s-2.608-3.546-7.72-3.546c0 0-2.294-3.234-5.945-3.964h-6.78s-2.608.417-6.259 3.86H1.85s-.626 1.043-.626 4.38c0 0-.417 3.338 2.191 3.338h.991M10.352 20.578h10.944"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.835 13.485-1.147.626h-9.91L8.37 12.703M10.352 20.578a2.973 2.973 0 1 1-5.946 0 2.973 2.973 0 0 1 5.946 0zM27.241 20.578a2.973 2.973 0 1 1-5.945 0 2.973 2.973 0 0 1 5.945 0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuAppAuto);
export default __webpack_public_path__ + "static/media/menu-app-auto.8cb6c04caf4dde708f28ada711725d88.svg";
export { ForwardRef as ReactComponent };